import { useMediaQuery, useTheme } from '@mui/material';

// ──────────────────────────────────────────────────────────────────────────
// useIsMobile — true below the 'sm' breakpoint (<600px, phones only).
//
// Deliberately narrower than App.tsx's own shell breakpoint ('md', 900px,
// which also catches tablets and only needs to swap the nav to a hamburger
// drawer). Tablets already reflow reasonably via each page's existing
// xs/md sx breakpoints — this hook is for the more aggressive per-page
// simplification (dropping sections, swapping tables for card-lists) that
// only a true phone needs.
// ──────────────────────────────────────────────────────────────────────────
export const useIsMobile = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'));
};
